
import styles from "./Style.module.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const PaymentMethodsLoader = () => {
  return (
    <div className={styles.paymentMethodsLoader}>
      <div className={styles.btnRow}>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
        <div className={styles.btnCol}>
            <Skeleton height={40} />
        </div>
      </div>
    </div>
  );
};

export default PaymentMethodsLoader;
